<template>
	<DialogControl v-model="open" :title="promoName || t('Claim')" icon="paid" max-width="440" :attach="overlayTarget" body-class="pt-3">
		<v-alert v-if="error" type="error" variant="tonal" density="compact" class="mb-3">{{ error }}</v-alert>
		<v-text-field v-model="editablePoints" type="number" inputmode="decimal" :step="POINTS_STEP" :min="POINTS_STEP" :label="t('PointsToClaimLabel')" variant="outlined" density="comfortable" class="mb-3" hide-details />
		<v-textarea v-model="comment" :label="t('Comment')" rows="3" variant="outlined" density="comfortable" hide-details />
		<template #actions>
			<v-btn variant="text" @click="open = false">{{ t('Cancel') }}</v-btn>
			<v-btn color="primary" variant="tonal" :loading="loading" :disabled="roundPoints(editablePoints) <= 0" @click="confirm">{{ t('Valid') }}</v-btn>
		</template>
	</DialogControl>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import { POINTS_STEP, roundPoints, limitPointsDecimals } from '@/api/sales/points';
import DialogControl from '@/components/controls/DialogControl.vue';

const t = useTranslator();

const props = defineProps({
	modelValue: { type: Boolean, default: false },
	promoName: { type: String, default: '' },
	calculatedPoints: { type: Number, default: 0 },
	loading: { type: Boolean, default: false },
	error: { type: String, default: null },
	overlayTarget: { type: Object, default: null },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const open = ref(props.modelValue);
const editablePoints = ref(0);
const comment = ref('');

watch(
	() => props.modelValue,
	(v) => {
		open.value = v;
		if (v) {
			editablePoints.value = 0;
			comment.value = '';
		}
	}
);

watch(open, (v) => emit('update:modelValue', v));

watch(editablePoints, (v) => {
	const limited = limitPointsDecimals(v);
	if (limited !== v) editablePoints.value = limited;
});

function confirm() {
	emit('confirm', { pointsClaimed: roundPoints(editablePoints.value), comment: comment.value });
}
</script>
